// extracted by mini-css-extract-plugin
module.exports = {"setsRow":"DocumentationSets_setsRow__1Fo_Q","docsRow":"DocumentationSets_docsRow__3dW17","tabs":"DocumentationSets_tabs__2rS6R"};